import { useEffect, useState } from "react"
import { debounce } from "lodash"

import useUrlQueryParams from "hooks/useUrlQueryParams"

import { TableSearchContent } from "./TableSearchContent"

interface Props {
  name?: string
  label?: string
}

export const TableSearch = ({ name, label }: Props) => {
  const [value, setValue] = useState("")
  const { urlQueryParams, setUrlQueryParams } = useUrlQueryParams()

  const handleClear = () => {
    setValue("")
    if (name) {
      setUrlQueryParams({ [name]: null })
    }
  }

  const onInputChange = (inputValue: string) => {
    if (name) {
      setUrlQueryParams({
        [name]: inputValue,
      })
    }
  }

  useEffect(() => {
    if (name && urlQueryParams[name] && !value) {
      setValue(urlQueryParams[name])
    } else if (urlQueryParams && name && !Object.hasOwn(urlQueryParams, name)) {
      setValue("")
    }
  }, [urlQueryParams])

  const debouncedOnInputChange = debounce(onInputChange, 500)

  return (
    <TableSearchContent
      name={name}
      label={label}
      value={value}
      onClear={handleClear}
      onInputChange={debouncedOnInputChange}
    />
  )
}
